import { render, staticRenderFns } from "./FiltersComponent.vue?vue&type=template&id=527761b0"
import script from "./FiltersComponent.vue?vue&type=script&lang=js"
export * from "./FiltersComponent.vue?vue&type=script&lang=js"
import style0 from "./FiltersComponent.vue?vue&type=style&index=0&id=527761b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports